import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { AdminChatUser, ChatsList } from "@/features/chats";
import { useAdminChats } from "../model/AdminChatsContext";

import styles from "./AdminChatsListPage.module.scss";

export const AdminChatsListPage = () => {
  const navigate = useNavigate();
  const { chats, chatsLoading, updateChatStage } = useAdminChats();
  const [selectedStage, setSelectedStage] = useState<string>("all");

  // Подсчет количества чатов по каждому stage
  const stageCounts = useMemo(() => {
    const counts: Record<string, number> = { all: chats.length };

    chats.forEach((chat) => {
      const stage = chat.stage || "Без статуса";
      counts[stage] = (counts[stage] || 0) + 1;
    });

    return counts;
  }, [chats]);

  // Получение уникальных стадий
  const stages = useMemo(() => {
    const uniqueStages = new Set<string>();
    chats.forEach((chat) => {
      if (chat.stage) {
        uniqueStages.add(chat.stage);
      } else {
        uniqueStages.add("Без статуса");
      }
    });
    return Array.from(uniqueStages).sort();
  }, [chats]);

  // Фильтрация чатов по выбранному stage
  const filteredChats = useMemo(() => {
    if (selectedStage === "all") {
      return chats;
    }

    return chats.filter((chat) => {
      const chatStage = chat.stage || "Без статуса";
      return chatStage === selectedStage;
    });
  }, [chats, selectedStage]);

  const description = useMemo(() => {
    if (!chats.length) {
      return "Список чатов пуст. Как только клиенты начнут писать, они появятся здесь.";
    }

    return "Выберите клиента, чтобы открыть его профиль, анкету и переписку.";
  }, [chats.length]);

  return (
    <section className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerTop}>
          <div>
            <h3 className={styles.title}>Клиенты</h3>
            <p className={styles.description}>{description}</p>
          </div>
          {chats.length > 0 && (
            <div className={styles.filterContainer}>
              <select
                value={selectedStage}
                onChange={(e) => setSelectedStage(e.target.value)}
                className={styles.stageSelect}
              >
                <option value="all">
                  Все ({stageCounts.all || 0})
                </option>
                {stages.map((stage) => (
                  <option key={stage} value={stage}>
                    {stage} ({stageCounts[stage] || 0})
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </header>

      <ChatsList
        chats={filteredChats}
        onSelect={(userId) => navigate(`/admin/chats/${userId}`)}
        onStageChange={updateChatStage}
        isLoading={chatsLoading}
        className={styles.list}
        showTitle={false}
      />
    </section>
  );
};

